import { render } from "./FollowQuestionPage.vue?vue&type=template&id=29a69076"
import script from "./FollowQuestionPage.vue?vue&type=script&lang=js"
export * from "./FollowQuestionPage.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__